import { TaskType } from "../task/model";

import { CREATE_IMMUNISATION_CASE_SUCCESS } from "../crud/ohCase/actiontypes";

import { OhCaseAction } from "../crud/ohCase/actions";

import * as models from "./models";
import { TriageAction } from "./actions";
import * as actions from "./actionTypes";

export function triages(state: models.TriageListModel[] = [], action: TriageAction): models.TriageListModel[] {
    switch (action.type) {
        case actions.TRIAGE_REFERRAL_SUCCESS:
        case actions.PPQ_NO_FURTHER_ACTION_SUCCESS:
        case actions.PPQ_TEMPORARILY_UNFIT_SUCCESS:
        case actions.TRIAGE_PHYSIOTHERAPY_REFERRAL_SUCCESS:
        case actions.TRIAGE_GENERIC_CASE_SUCCESS:
            return state.filter(triageTask => triageTask.caseId !== action.payload);
        case actions.LOAD_TRIAGES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function triage(state: models.TriageDetailModel | null  = null, action: TriageAction | OhCaseAction): models.TriageDetailModel | null {
    switch (action.type) {
        case actions.TRIAGE_REFERRAL_SUCCESS:
        case actions.PPQ_NO_FURTHER_ACTION_SUCCESS:
        case actions.PPQ_TEMPORARILY_UNFIT_SUCCESS:
        case actions.TRIAGE_PHYSIOTHERAPY_REFERRAL_SUCCESS:
        case actions.TRIAGE_GENERIC_CASE_SUCCESS:
            return null;
        case actions.LOAD_REFERRAL_TRIAGE_SUCCESS:
        case actions.LOAD_PPQ_TRIAGE_SUCCESS:
        case actions.LOAD_PHYSIOTHERAPY_REFERRAL_TRIAGE_SUCCESS:
        case actions.LOAD_GENERIC_CASE_TRIAGE_SUCCESS:
            return action.payload;
        case CREATE_IMMUNISATION_CASE_SUCCESS:
            return state && action.payload.linkedOhCases && action.payload.linkedOhCases.some(l => l.id === state.caseId) ?
                { ...state, linkedOhCases: [ { id: action.payload.id, caseType: action.payload.caseType } ] } :
                state;
        default:
            return state;
    }
}

export function referralTriageTasks(state: TaskType[] | null = null, action: TriageAction): TaskType[] | null {
    switch (action.type) {
        case actions.REFERRAL_TRIAGE_TASKS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function ppqTriageTasks(state: TaskType[] | null = null, action: TriageAction): TaskType[] | null {
    switch (action.type) {
        case actions.PPQ_TRIAGE_TASKS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function physiotherapyReferralTriageTasks(state: TaskType[] | null = null, action: TriageAction): TaskType[] | null {
    switch (action.type) {
        case actions.PHYSIOTHERAPY_REFERRAL_TRIAGE_SUCCESSOR_TASKS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function genericCaseTriageTasks(state: TaskType[] | null = null, action: TriageAction): TaskType[] | null {
    switch (action.type) {
        case actions.GENERIC_CASE_TRIAGE_SUCCESSOR_TASKS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
